<template>
  <transition name="default-opacity-transition" mode="out-in">
    <s-loader v-if="loading" />
    <router-view
      v-else
      :key="assetModule && assetModule.id"
      :asset="currentAsset || {}"
      :asset-type="currentAssetType"
      :asset-module="assetModule"
    />
  </transition>
</template>
<script>
import ModuleMenuService from '@/domain/services/installation/modules/menu';
import loadingMixin from '@/services/loadingMixin';
import eventBus from '@/services/globalEventBus';
import AssetAccessorMixin from '@/domain/mixins/installation/assetAccessorMixin';
import AssetTreeviewInstallationAcessMixin from '@/components/treeview/assetTreeviewInstallationAcessMixin';
import menuEvents from '@/domain/events/menu';
import { mapGetters } from 'vuex';

export default {
  name: 'Engineering',
  mixins: [
    loadingMixin,
    AssetAccessorMixin,
    AssetTreeviewInstallationAcessMixin,
  ],
  data: () => ({
    modulesList: [],
    assetModule: null,
  }),
  computed: {
    ...mapGetters([
      'assetSubMenu',
    ]),
  },
  created() {
    this.initListener();
    this.handleMenuItems(this.assetSubMenu.items);
  },
  beforeDestroy() {
    this.removeListener();
  },
  beforeRouteUpdate(to, from, next) {
    this.startLoading();
    next();
    this.handleMenuItems(this.assetSubMenu.items);
    this.endLoading();
  },
  methods: {
    initListener() {
      eventBus.on(menuEvents.refreshMenuItems, this.handleMenuItems, this);
    },
    removeListener() {
      eventBus.off(menuEvents.refreshMenuItems, this.handleMenuItems, this);
    },
    async handleMenuItems(menuItems) {
      if (!menuItems) {
        return;
      }
      this.startLoading();
      this.modulesList = await ModuleMenuService.mapEngineeringModuleList(menuItems);
      this.assetModule = await ModuleMenuService
        .verifyEngineeringRoute(this.$route, this.modulesList);
      this.$route.meta.currentRouteModuleSubtype = this.assetModule?.subtype || '';
      this.endLoading();
    },
  },
};
</script>
